<section class="button-wrapper {{tag}}" [ngClass]="{'multi-buttons':type === 'split', 'full_size_wrapper':fullSize, 'button-center':position === 'center'}">
    <ng-container *ngIf="permissionKey">
        <button class="Auto_Button_{{type}} gen-button-element {{btnClasses}} {{buttonClass}}" #mainButton
                type="{{submit ? 'submit':'button'}}"
                [disabled]="!!disabled"
                [ngClass]="{active:active,disabled:disabled,'circular_btn':round, 'circular-split-btn': type==='split','proceed-button':type ==='proceed','content-shown-button': showDropdownContent,'full_size':fullSize,'min_padding':minPadding}"
                genPermissionSchemaRestrict [permissionSchemaKey]="permissionKey"
                [nonePermissionAction]="permissionAction"
                (notifyPermissionState)="updateEditableAllow($event)"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="innerBlock"></ng-template>
        </button>
    </ng-container>
    <ng-container *ngIf="!permissionKey && buttonClass != 'button-treatment-selection-notes'">
        <button class="Auto_Button_{{type}} gen-button-element {{btnClasses}} {{buttonClass}}" #mainButton
                type="{{submit ? 'submit':'button'}}"
                [disabled]="!!disabled"
                [ngClass]="{active:active,disabled:disabled,'circular_btn':round, 'circular-split-btn': type==='split','proceed-button':type ==='proceed','content-shown-button': showDropdownContent,'full_size':fullSize,'min_padding':minPadding}"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="innerBlock"></ng-template>
        </button>
    </ng-container>
    <ng-container *ngIf="!permissionKey && buttonClass == 'button-treatment-selection-notes'">
        <button class="Auto_Button_{{type}} gen-button-element button__icon {{btnClasses}} {{iconClass}} {{buttonClass}}" #mainButton
                type='button'
                [disabled]="!!disabled"
                [ngClass]="{active:active,disabled:disabled,'circular_btn':round, 'circular-split-btn': type==='split','proceed-button':type ==='proceed','content-shown-button': showDropdownContent,'full_size':fullSize,'min_padding':minPadding}"
                genTooltip [tooltipPosition]="tooltipPosition"
                [tooltipConfiguration]="tooltipConfiguration"
                [tooltipShow]="tooltipShow"
                [minTooltipHeight]="200"
                [fixedTooltipWidth]="800">
        </button>
    </ng-container>
    <section *ngIf="type=='split'">
        <button class="{{dropDownIconClass}} Auto_Button_split_dropdown gen-button-element {{btnClasses}} circular-split-dropdown-btn split-button"
                [disabled]="!!disabled"
                [ngClass]="{active:active, disabled:disabled, 'content-shown-dropdown': showDropdownContent}"
                (click)="dropdownClick($event)">
        </button>
        <section [ngClass]="{'hidden':!showDropdownContent}" (clickOutside)="hideDropdown()"
                 (click)="$event.stopPropagation();" class="overlay" #detailsSection>
            <ng-content></ng-content>
        </section>
    </section>
</section>

<ng-template #innerBlock>
  <i class="button__icon {{iconClass}}" *ngIf="iconClass" genTooltip
     [tooltipText]="tooltipText|stringTranslate"
     [tooltipPosition]="tooltipPosition"
     [tooltipShow]="tooltipShow"
     [tooltipYOffset]="tooltipYOffset">
  </i>
  <span class="button__text" [innerHtml]="text" *ngIf="!!text" translate [ngClass]="{'disabled':disabled}"
        [ngClass]="textClass"></span>
  <ng-content select="[contentProjectedData]"></ng-content>
</ng-template>
